module.exports = __webpack_public_path__ + "i18n/ru.1d9a33ed0494a2fc6e13e80f92f2bad9.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ru.json
// module id = 1004
// module chunks = 60